import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EmailIcon(props: IconProps) {
    return <Icon {...props} iconKey={"email"}/>
}
